import { Injectable } from '@angular/core';
import { MychatroomComponent } from './mychatroom.component';
import { Headers, Response, Http, RequestOptions } from '@angular/http';
import { map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import "rxjs/Rx";
import 'rxjs/add/operator/toPromise';
import { Observable } from "rxjs/Observable";
import { DynamicMessageComponent } from '../../components/dynamicMessage/dynamicMessage.component';
import { HttpService } from '../../services/httpService';
import * as $ from 'jquery';
import { ChatMessage } from '../../entities/chat-message.module';
import { ApiService } from '../../services/api.service';



@Injectable()
export class MychatroomService {
    

    mychatroomUrl: string = 'entry/mychatroom/?requestType=JSON';

    constructor(private http: Http, private httpService: HttpService,
        private apiService: ApiService) {
    }
    getNowTime(): string {
        var dd = new Date();
        var y = dd.getFullYear();
        var m = dd.getMonth();
        var d = dd.getDate();
        var h = dd.getHours(); 
        var mi = dd.getMinutes(); 
        var s = dd.getSeconds();
        var nyr = y+"-"+(m+1)+"-"+d;
        return nyr+" "+(h<10?('0'+h):(h)) + ':' + (mi<10?('0'+mi):(mi)) + ':' + (s<10?('0'+s):(s));
      }
      
    loadMyMessage(domainId: string, mychatroomComponent: MychatroomComponent) {
        let url = 'entry/loadMyMessage?domainId=' + domainId;
        this.httpService.get(url).subscribe(
            result => {
            //   if (res['code'] === 200 && res['data'] !== null) {
            //     this.favoriteStatus = true;
            //   } else {
            //     this.favoriteStatus = false;
            //   }
            if(!result) return;

             let msg = result.msg;

             if (msg !== '') {
                let bb = result.userName;
                const respComponent = mychatroomComponent.componentFactory.resolveComponentFactory(DynamicMessageComponent);
                  const respCom = mychatroomComponent.content.createComponent(respComponent);
                  respCom.instance.userName = '佐伦';//Jacky';
                  respCom.instance.inputMessage = msg;
                  respCom.instance.isResponse = true;
                  respCom.instance.sendTime =  this.getNowTime();
             }

            },
            err => {
              console.log('favorite module error ', err);
            },
            () => {
            //   this.isProcessing = false;
            }
          );
    }

    getLoginUserName():  string[] {
        let bb = ' -- ';
        let domain = '--';
            $.ajax({
               url: 'entry/mychatroom?requestType=JSON&jsMethod=getLoginUserName',
               type: 'POST',
               async: false,
               data: {list_item: 'selected_from_list'},
               success: function(result){
                   // var json = $.parseJSON(result);
                  bb = result.userName;
                  domain = result.domainId;
               },
               error: function(e){
                   alert('error:' + e);
               }
            });
        return [bb, domain];
    }

    
    sendMessage2JackExt(message: ChatMessage, mychatroomComponent: MychatroomComponent): string {

        this.apiService.post('/api/chat/say2jack', message).subscribe((respnose:any)=>{
            
            // const respJson = JSON.parse(respnose);
            // serv2.showResponse(respnose, respJson);
            if(message.waitResponse=='1'){
                mychatroomComponent.createRespBlock(respnose.responseMessage, respnose.debugMessage);
                // const respComponent = mychatroomComponent.componentFactory.resolveComponentFactory(DynamicMessageComponent);
                // const respCom = mychatroomComponent.content.createComponent(respComponent);
                // respCom.instance.userName = '佐伦';//Jacky';
                // respCom.instance.inputMessage = respnose.responseMessage;
                // respCom.instance.isResponse = true;
                // respCom.instance.sendTime =  this.getNowTime();
            }

        });
        
        return null;
      }

      loadChatingTypeList(): Observable<Array<any>> {
        return this.apiService.get('/api/chat/loadChatingType');
      }

    sendMessage2Jack(messageContent: string, messageContent2: string,  learningType: string,
         mychatroomComponent: MychatroomComponent): string {
        let bb = ' -- ';
            $.ajax({
               url: 'entry/mychatroom?requestType=JSON&jsMethod=sendMessage2Jack',
               type: 'POST',
               async: true,
               contentType: 'application/json',
               dataType: 'json',
               data: {'test': 'aabb', 'content': messageContent, 'content2': messageContent2, 'learningType': learningType},
               success: function(result){
                  // var json = $.parseJSON(result);
                   if(result != null && result != undefined && result.logout && result.logout=='true'){
                     location.href = "/";
                     return;
                   }
                   //bb = json.msg;
                  const respComponent = mychatroomComponent.componentFactory.resolveComponentFactory(DynamicMessageComponent);
                   const respCom = mychatroomComponent.content.createComponent(respComponent);
                   respCom.instance.userName = 'Jacky';
                   if(result==null || result == undefined) {
                       respCom.instance.inputMessage = 'OK';
                   }else{
                       respCom.instance.inputMessage = result.msg;
                   }
                   respCom.instance.isResponse = true;
               },
               error: function(e){
                   alert('error:' + e);
               }
            });
        return  bb;
    }


    extractData(res: Response) {
        let mychatroomData: any = res.json();
        return mychatroomData;
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}
